import { GET_USER } from 'utils/types.utils';
import { storeAction } from 'interfaces/common.interface';

const initialState = {
  user: {},
};

const UserReducer = (state = initialState, action: storeAction) => {
  switch (action.type) {
    case GET_USER:
      return {
        ...state,
        user: action.payload,
      };

    default:
      return state;
  }
};

export default UserReducer;
